import axios from "axios";
// import { get_CSRFToken } from "../utils/CSRFToken";
import { getUserInfo } from "../utils/UserInfo";

const Call = (method, url, data) => {
  // const URL = `https://test.softomega.ir/menu/api/${url}`;
  // const URL = `http://localhost:8000/menu/api/${url}`;
  // const URL = `http://192.168.43.211/menu/api/${url}`;
  // const URL = `https://demo.softomega.ir/menu/api/${url}`;
  // const protocol = window.location.protocol
  // const host = window.location.hostname
  // const port = window.location.port
  // const URL =  protocol + "//" + host + ":" + port + `/menu/api/${url}`;
  // const URL = `http://localhost:6060/${url}`
  const URL = `http://217.144.106.32:6565/${url}`;
  // const URL = `http://192.168.100.9:6565/${url}`;
  //   const csrfToken = get_CSRFToken();
  const userInfo = getUserInfo();
  let authToken;
  if (userInfo === null) {
    authToken = "";
  } else {
    authToken = userInfo.token;
  }
  switch (method) {
    case "POST":
      return axios({
        headers: {
          // 'X-CSRFToken' : csrfToken,
          token: authToken,
          "Content-Type": "application/json",
        },
        url: URL,
        method: method,
        data: data,
      });
    case "GET":
      return axios({
        headers: {
          // "Access-Control-Allow-Origin": "*",
          token: authToken,
          "Content-Type": "application/json",
        },
        url: URL,
        method: method,
        data: data,
        params: data,
      });
    case "PUT":
      return axios({
        headers: {
          "Access-Control-Allow-Origin": "*",
          //   "X-CSRFToken": csrfToken,
          //   Authorization: authToken,
        },
        url: URL,
        method: method,
        data: data,
      });
    case "DELETE":
      return axios({
        headers: {
          "Access-Control-Allow-Origin": "*",
          //   "X-CSRFToken": csrfToken,
          //   Authorization: authToken,
        },
        url: URL,
        method: method,
        data: data,
      });
    default:
      return null;
  }
};

export default Call;
